export const log = {
  network(...args: unknown[]) {
    if (__DEV__) {
      console.debug("%c[Network]", "color: gray", ...args);
    }
  },
  dev(...args: unknown[]) {
    if (__DEV__) {
      console.info("%c[dev]", "color: red", ...args);
    }
  },
  analytics(...args: unknown[]) {
    if (__DEV__) {
      console.info("%c[Analytics]", "color: green", ...args);
    }
  },
  error(...args: unknown[]) {
    if (__DEV__) {
      console.error("%c[ERROR]", "color: red", ...args);
    }
  },
};
